module.exports = __webpack_public_path__ + "img/default-unknow-phone.a594d3dd.jpeg";